import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SessionStorageService } from '../Services/sessionStorageService/session-storage.service';

@Component({
  selector: 'app-AgencyRegister',
  templateUrl: './AgencyRegister.component.html',
  styleUrls: ['./AgencyRegister.component.scss']
})
export class AgencyRegisterComponent implements OnInit {

  public type: string;
  constructor(private activeRoute: ActivatedRoute, private lsService : SessionStorageService) { }

  ngOnInit() {
    this.activeRoute.queryParams.subscribe((param) => {
      if (param.type) {
        if (param.type != undefined) {
          this.type = param.type;
          this.lsService.setLSItem('type', this.type)
        }
        else {
          this.type = this.lsService.getLSItem('type')
        }

      }
    });
    if (this.type == undefined) {

      this.type = this.lsService.getLSItem('type')

    }

    this.lsService.removeLSItem('type');
  }

}
